import React from 'react';
import PageTitle from '../components/PageTitle';
import PricingIntro from '../components/pricing/PricingIntro';
import PricingFeatures from '../components/pricing/PricingFeatures';
import PriceTable from '../components/PriceTable';
import Faq from '../components/Faq';
import ContactForm from '../components/ContactForm';

const PricingPage = () => {
    return (
        <main id="infocolors-main">
            <div className="stg-container">
                <PageTitle
                    title="Pricing"
                    subtitle="We help businesses of all sizes achieve their goals 🏆. We believe every brand, big or small, deserves to shine."
                />
                <PricingIntro />
                <PricingFeatures />
                <PriceTable />
                <Faq />
                <ContactForm />
            </div>
        </main>
    );
};

export default PricingPage;
